import React from "react";
import styled from "styled-components";

const FooterStyle = styled.div`
    opacity: .5;
    text-align: center;
    color: ${props => props.theme.white};
`;

export const Footer = ({ children }) =>
    <FooterStyle>
        <div>
            {children}
        </div>
    </FooterStyle>;